"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAUTH_PROVIDER_IDS = exports.OAUTH_PROVIDERS_METADATA = void 0;
exports.getOAuthProviderMetadata = getOAuthProviderMetadata;
/**
 * Centralized OAuth provider metadata for UI display
 * This includes display names, icons, and colors for each provider
 */
exports.OAUTH_PROVIDERS_METADATA = [
    {
        id: "google",
        name: "Google",
        color: "bg-white hover:bg-gray-50 text-gray-900 border",
    },
    {
        id: "apple",
        name: "Apple",
        color: "bg-black hover:bg-gray-900 text-white",
    },
    {
        id: "facebook",
        name: "Facebook",
        color: "bg-blue-600 hover:bg-blue-700 text-white",
    },
    {
        id: "github",
        name: "GitHub",
        color: "bg-gray-800 hover:bg-gray-900 text-white",
    },
    {
        id: "slack",
        name: "Slack",
        color: "bg-[#4A154B] hover:bg-[#611f69] text-white",
    },
    {
        id: "atproto",
        name: "Bluesky",
        color: "bg-sky-500 hover:bg-sky-600 text-white",
    },
];
/**
 * Helper to get metadata for a specific provider
 */
function getOAuthProviderMetadata(providerId) {
    return exports.OAUTH_PROVIDERS_METADATA.find((p) => p.id === providerId);
}
/**
 * List of supported OAuth provider IDs
 */
exports.OAUTH_PROVIDER_IDS = exports.OAUTH_PROVIDERS_METADATA.map((p) => p.id);
